module.exports = __webpack_public_path__ + "static/global-web-hosting-0c3ce7f276061d69d24ccf08cc2c2ac5.jpg";